/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RestoreSkillVersionRequestBody = {
  /**
   * The skill ID.
   */
  id: string;
  /**
   * The historical version to restore.
   */
  versionId: string;
};

/** @internal */
export type RestoreSkillVersionRequestBody$Outbound = {
  id: string;
  version_id: string;
};

/** @internal */
export const RestoreSkillVersionRequestBody$outboundSchema: z.ZodMiniType<
  RestoreSkillVersionRequestBody$Outbound,
  RestoreSkillVersionRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    versionId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      versionId: "version_id",
    });
  }),
);

export function restoreSkillVersionRequestBodyToJSON(
  restoreSkillVersionRequestBody: RestoreSkillVersionRequestBody,
): string {
  return JSON.stringify(
    RestoreSkillVersionRequestBody$outboundSchema.parse(
      restoreSkillVersionRequestBody,
    ),
  );
}
